import React from 'react';
import { CreateCredentialsState } from './createCredentialsState/CreateCredentialsState';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import { CreationForm } from './components/CreationForm/CreationForm';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

export const CreateCredentialsPage: React.FC = () => {
	return (
		<CreateCredentialsState>
			<WithAdditionalValidationState>
				<CreationForm />
			</WithAdditionalValidationState>
			<ModalWindows />
		</CreateCredentialsState>
	);
};
